import { Loader2 } from "lucide-react";
import type { TransferRequest } from "@/features/employeeTransfer/types/employeeTransfer.types";
import { H2 } from "@/shared/ui/typographies/h2";
import { P } from "@/shared/ui/typographies/paragraph";

type ProcessingScreenProps = {
  percent: number
  transferRequest: TransferRequest
};

export const ProcessingScreen = ({ percent, transferRequest }: ProcessingScreenProps) => {
  const { source_organization_name: sourceOrg, target_organization_name: targetOrg } = transferRequest;

  return (
    <div className="overflow-hidden rounded-xl" aria-live="polite">
      <div className="bg-blue-50/80 px-6 py-8 dark:bg-blue-950/20">
        <div className="flex flex-col items-center text-center">
          <div className="mb-4 flex h-14 w-14 items-center justify-center rounded-full bg-blue-100 dark:bg-blue-900/30">
            <Loader2 size={28} className="animate-spin text-blue-600 dark:text-blue-400" />
          </div>
          <H2 className="mb-2 text-xl font-bold text-gray-900 dark:text-white">
            Transfert en cours...
          </H2>
          <P size="sm" color="base" className="text-pretty tracking-wider">
            De
            {" "}
            <strong className="text-gray-900 dark:text-white">{sourceOrg}</strong>
            {" "}
            vers
            {" "}
            <strong className="text-gray-900 dark:text-white">{targetOrg}</strong>
          </P>
        </div>
      </div>

      <div className="space-y-4 px-6 pb-6 pt-4">
        <div className="h-3 w-full overflow-hidden rounded-full bg-gray-200 dark:bg-gray-700">
          <div
            className="h-full rounded-full bg-blue-600 transition-all duration-500 ease-out dark:bg-blue-500"
            style={{ width: `${Math.max(percent, 2)}%` }}
            role="progressbar"
            aria-label="Progression du transfert"
            aria-valuenow={percent}
            aria-valuemin={0}
            aria-valuemax={100}
          />
        </div>
        <P size="sm" color="base" className="text-pretty tracking-wider text-center">
          Veuillez patienter pendant le transfert de votre compte.
        </P>
      </div>
    </div>
  );
};
